import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "check",
  "use": "check-usage",
  "viewBox": "0 0 50 50",
  "content": "<symbol viewBox=\"0 0 50 50\" xmlns=\"http://www.w3.org/2000/svg\" id=\"check\"><path d=\"M43.947 5L18.29 31.612 5.526 20.526 0 26.875l15.79 13.684 3.026 2.632 2.763-2.895L50 10.822z\" fill=\"#FFF\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol